module.exports = __webpack_public_path__ + "img/icon_win.6c1df83c.png";